module.exports = __webpack_public_path__ + "static/bassoon_en-7fa76491c2627c1f20d04e0971cdb48d.pdf";